import { axiosInstance } from '@/core/services';

const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string) || 'http://localhost:3000/api';

export const deleteInitialQuestionnaire = async (id: string): Promise<void> => {
  await axiosInstance.delete(`${API_BASE_URL}/initial-questionnaire/${id}`);
};
